import { useState } from 'react';
import * as R from 'ramda';
import { loginAPI } from "../../util/api";
import LoginForm from "../../forms/LoginForm";
import { getRouteLocation } from "../../util/utility";
import LoadingModal from "../dumb/LoadingModal";
import { useHistory } from 'react-router';

function LoginComponent() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    let history = useHistory();
    return (
        <div>
            {
                !R.isNil(error) && (<div style={{ color: 'red' }}> Invalid username or password </div>) 
            }
            <LoginForm
                onClick={(email, password) => {
                    setLoading(true);
                    return loginAPI(email, password)
                    .then(({ user, token }) => {
                        let routeLocation = getRouteLocation(user.role);
                        // route to the correct place
                        setLoading(false);
                        window.localStorage.setItem('token', token);
                        history.push(routeLocation);
                    })
                    .catch(error => {
                        console.log(`error = ${error}`);
                        setError(true);
                        setLoading(false);
                    })
                }}
            />
            {
                loading && <LoadingModal />
            }
        </div>
    );
}

export default LoginComponent;